import Reflux from 'reflux'

import AuthStore from '~/stores/auth.js'


export default class OnlyIfAuthorized extends Reflux.Component {
	constructor(props) {
		super(props)

		// store subscriptions
		this.store = AuthStore
		this.storeKeys = ['authenticated']
	}

	// ********************************************************************************
	// ********************************************************************************

	render() {
		return (this.state.authenticated === true)
			? this.props.children
			: null
	}
}



// WEBPACK FOOTER //
// ./src/modules/onlyIfAuthorized/index.jsx